<p-dialog
    #inserirBloqueio
    [(visible)]="visible"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '36rem' }"
    [modal]="true"
    [closable]="true"
    [resizable]="false"
    [draggable]="false"
    (onHide)="fechar()"
    [transitionOptions]="'0ms'"
>
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2 w-full">
            <span class="text-xl font-semibold text-900">Novo Bloqueio</span>
            <div
                class="flex align-items-center gap-1 px-2 py-1 border-1 surface-border border-round"
            >
                <i class="pi pi-calendar text-700"></i>
                <span class="text-900 text-base">
                    {{ dataBloqueio | date : "dd/MM/yyyy" }}
                </span>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <p-messages
            [(value)]="messagesDialog"
            [enableService]="false"
            [closable]="true"
        ></p-messages>
        <form #bloqueioForm="ngForm" class="grid p-fluid formgrid">
            <div class="col-12 md:col-12 field">
                <label for="title" class="text-900 font-semibold">Título</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-pencil"></i>
                    <input
                        id="title"
                        type="text"
                        pInputText
                        name="titulo"
                        placeholder="Digite o título"
                        [(ngModel)]="bloqueioAgenda.titulo"
                        #titulo="ngModel"
                        required
                    />
                </span>
                <small class="p-error" *ngIf="titulo.invalid && titulo.touched">
                    Título é obrigatório
                </small>
            </div>

            <div class="col-12 field">
                <label for="description" class="text-900 font-semibold">Descrição</label>
                <textarea
                    id="description"
                    type="text"
                    pInputTextarea
                    [rows]="2"
                    [(ngModel)]="bloqueioAgenda.descricao"
                    #descricao="ngModel"
                    name="descricao"
                    style="resize: none"
                ></textarea>
            </div>

            <div class="col-12 md:col-12 field">
                <label for="start" class="text-900 font-semibold">Profissional</label>
                <p-dropdown
                    [options]="selectProfissinaisBloqueio"
                    optionLabel="label"
                    optionValue="value"
                    name="profissional"
                    #profissional="ngModel"
                    emptyMessage="Nenhum registro"
                    placeholder="Selecione o profissional"
                    [(ngModel)]="profissinalSelecionado"
                    appendTo="body"
                ></p-dropdown>
            </div>
        </form>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-between">
            <button
                pButton
                (click)="salvarBloqueio()"
                label="Salvar"
                icon="pi pi-check w-3"
                class="p-button-outlined p-button-success"
                [disabled]="!bloqueioAgenda.titulo"
            ></button>
            <button
                pButton
                (click)="visible = false"
                class="p-button-outlined p-button-danger w-3"
                label="Cancelar"
                icon="pi pi-times"
            ></button>
        </div>
    </ng-template>
</p-dialog>